var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.986,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5.26702C6 5.34515 6 5.42326 6 5.50139C5.8732 5.86567 5.6193 6.00435 5.23828 5.91741C5.18087 5.90043 5.12619 5.87699 5.07422 5.84709C4.37727 5.16188 3.68392 4.47241 2.99414 3.77874C2.30436 4.47241 1.61101 5.16188 0.914062 5.84709C0.764222 5.93046 0.604065 5.9578 0.433594 5.92913C0.202379 5.87953 0.057848 5.74086 0 5.51311C0 5.43498 0 5.35686 0 5.27874C0.0278143 5.16847 0.0805487 5.07081 0.158203 4.98577C0.832031 4.31194 1.50586 3.63811 2.17969 2.96428C1.48601 2.2745 0.796552 1.58115 0.111328 0.884204C-0.0475943 0.565381 0.0129526 0.297803 0.292969 0.0814695C0.511595 -0.0344758 0.726439 -0.0266633 0.9375 0.104907C1.62663 0.782318 2.31218 1.46395 2.99414 2.14983C3.6722 1.46787 4.35383 0.79013 5.03906 0.116626C5.17823 0.0242406 5.33058 -0.00700942 5.49609 0.0228757C5.84616 0.130934 5.99264 0.367263 5.93555 0.73186C5.9137 0.802873 5.88246 0.869279 5.8418 0.931079C5.16586 1.60507 4.49203 2.28084 3.82031 2.95842C4.49626 3.64413 5.17789 4.32382 5.86523 4.99749C5.9293 5.07873 5.97422 5.16858 6 5.26702Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.92fbd6c492b1a141a20a79c1ad3c4d71.svg";
export { ForwardRef as ReactComponent };